<div class="content">
    <h2>Einstellungen</h2>

    <mat-accordion multi="true">
        <mat-expansion-panel data-qa="kundenbetreuer">
            <mat-expansion-panel-header data-qa="settings-item">
                <mat-panel-title>Kundenbetreuer</mat-panel-title>
            </mat-expansion-panel-header>
            <tnb-settings-kundenbetreuer></tnb-settings-kundenbetreuer>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="schaltleitungen">
            <mat-expansion-panel-header data-qa="settings-item">
                <mat-panel-title>Schaltleitungen</mat-panel-title>
            </mat-expansion-panel-header>
            <tnb-settings-schaltleitungen></tnb-settings-schaltleitungen>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="email-templates">
            <mat-expansion-panel-header data-qa="settings-item">
                <mat-panel-title>E-Mail-Templates</mat-panel-title>
            </mat-expansion-panel-header>
            <tnb-settings-emailtemplates></tnb-settings-emailtemplates>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="schnittstellen-benutzer">
            <mat-expansion-panel-header data-qa="settings-item">
                <mat-panel-title>Schnittstellen Benutzer</mat-panel-title>
            </mat-expansion-panel-header>
            <tnb-settings-users></tnb-settings-users>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="netzzuordnung-import">
            <mat-expansion-panel-header>
                <mat-panel-title>Netzzuordnung Import</mat-panel-title>
            </mat-expansion-panel-header>
            <tnb-settings-netzzuordnung-import></tnb-settings-netzzuordnung-import>
        </mat-expansion-panel>
    </mat-accordion>
</div>

